// extracted by mini-css-extract-plugin
export default {"resendWrapper":"styles_resendWrapper__412u8"};